class CampsiteNavigation extends HTMLElement {
  constructor () {
    super()
    this.isScrolling = false
    this.sections = this.populateSections()
    this.addButtonClickListeners()
    this.addScrollListener()
    this.scrollTimeout = null
  }

  populateSections () {
    const sections = []
    this.buttons.forEach((button) => {
      const sectionId = button.dataset.link
      if (sectionId) {
        const section = document.querySelector(`#${sectionId}`)
        if (section) {
          sections.push(section)
        }
      }
    })
    return sections
  }

  addButtonClickListeners () {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const sectionId = button.dataset.link
        const section = this.sections.find((section) => section.id === sectionId)
        if (section) {
          this.isScrolling = true

          // Center the clicked button immediately
          button.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          })

          const targetScrollY = window.scrollY + section.getBoundingClientRect().top - 140

          window.scrollTo({
            top: targetScrollY,
            behavior: 'smooth',
          })
          this.updateButtonClasses(sectionId)

          setTimeout(() => {
            this.isScrolling = false
          }, 1000)
        }
      })
    })
  }

  addScrollListener () {
    window.addEventListener('scroll', () => this.onScroll(), { passive: true })
    this.onScroll()
  }

  onScroll () {
    if (this.isScrolling) return

    // Update active state immediately
    const viewportHeight = window.innerHeight
    let activeSectionId = null
    let minDistance = Infinity

    this.sections.forEach((section) => {
      const rect = section.getBoundingClientRect()
      if (rect.top <= viewportHeight / 2) {
        const distance = Math.abs(rect.top)
        if (distance < minDistance) {
          minDistance = distance
          activeSectionId = section.id
        }
      }
    })

    if (activeSectionId) {
      this.updateButtonClasses(activeSectionId)
    }

    // Remove the debounced button centering completely
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
  }

  updateButtonClasses (activeSectionId, centerButton = false) {
    this.buttons.forEach((button) => {
      const sectionId = button.dataset.link
      if (sectionId === activeSectionId) {
        button.style.borderBottomColor = 'black'
        if (centerButton) {
          button.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          })
        }
      } else {
        button.style.borderBottomColor = 'transparent'
      }
    })
  }

  get buttons () {
    return this.querySelectorAll('button[data-link]')
  }
}

if (!customElements.get('campsite-nav')) {
  customElements.define('campsite-nav', CampsiteNavigation)
}
